import React, { Component } from 'react';

import { 
    WFInput, 
} from '../../../components/wireframes/modules';

import Header from '../components/Header';
import Footer from '../components/Footer';
import SessionsTable from '../components/SessionsTable';

class Sessions extends Component {
    async componentDidMount() {
        await this.props.allow_sessions_get_all();
    }

    render() {
        const {
            data = [],
        } = this.props.allow_sessions;

        return (
            <div>
                <Header />

                <hr />

                <div className="wf-container">
                    <div className="wf-row">
                        <div className="wf-col-6">
                            <WFInput 
                                name={'email'}
                                label={'User Email'}
                                validation={(value) => value.length > 5}
                                submit={(value)=> { this.props.allow_sessions_get_all({
                                    email: value.email,
                                }) }}
                            />
                            <button>Search all sessions</button>
                        </div>
                    </div>
                </div>
                
                <hr />

                <div className="wf-container">
                    <div className="wf-row">
                        <div className="wf-col-12">
                            <SessionsTable 
                                data={data}
                            />
                        </div>
                    </div>
                </div>

                <Footer />

            </div>
        );
    }
}

export default Sessions;